"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartCallbackType = void 0;
/**
 * Determines when the AtlasEngine will resolve after a new ProcessInstance was started.
 */
var StartCallbackType;
(function (StartCallbackType) {
    /**
       * The AtlasEngine will resolve immediately after the ProcessInstance was started.
       */
    StartCallbackType[StartCallbackType["CallbackOnProcessInstanceCreated"] = 1] = "CallbackOnProcessInstanceCreated";
    /**
       * The AtlasEngine will resolve after the first EndEvent was reached.
       */
    StartCallbackType[StartCallbackType["CallbackOnProcessInstanceFinished"] = 2] = "CallbackOnProcessInstanceFinished";
    /**
       * The AtlasEngine will resolve after a specific EndEvent was reached.
       */
    StartCallbackType[StartCallbackType["CallbackOnEndEventReached"] = 3] = "CallbackOnEndEventReached";
})(StartCallbackType = exports.StartCallbackType || (exports.StartCallbackType = {}));
//# sourceMappingURL=ProcessStartOptions.js.map